<template>
  <div v-bind:style="{backgroundSize:bgs}" id="mainFull" class="full test">
  </div>
</template>

<script>
export default {
  name: 'FullView',
  data: function(){
    return {
      bgs_w: "100vw",
      bgs_h: "auto",
      bgs_now: "100vw",
    }
  },
  computed: {
    bgs: function () {
      return `${this.bgs_w} ${this.bgs_h}`;
      // return "100% "
    }
  },
  methods: {
    // changeSize: function(){
    //   var ratio = window.parent.screen.width / window.parent.screen.height;
    //   if(ratio <= 1.500524659){
    //     this.bgs_w = "auto";
    //     this.bgs_h = this.bgs_now;
    //   }else{
    //     this.bgs_w = this.bgs_now;
    //     this.bgs_h = "auto";
    //   }
    // }
  },
  mounted: function(){
    // var _this = this;
    // window.addEventListener('resize', function(){
    //   _this.changeSize();
    // })
    // window.addEventListener('scroll', function(){
    //   var element = document.getElementById('mainFull');
    //   var rect = element.getBoundingClientRect();
    //   if(rect.y < window.innerHeight / 3){
    //     _this.bgs_now = "120vw";
    //   }else{
    //     _this.bgs_now = "100vw";
    //   }
    //   _this.changeSize();
    // })
  }
}

// width / height = 1.500524659
</script>

<style scoped>
.full{
    width: 100%;
    height: 100vh;
    background: url(../assets/subimage.png) center center no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    transition: background-size 600ms ease;
}
@media screen and (max-width:480px){
  .full{
    height: 60vh;
  }
}

</style>
